/**
 * @author: lv.chen
 * @date: 2025/11/18
 * @desc: ReuseTabPageTemplate页面模板
 */
import React from 'react';
import classnames from 'classnames';
import { Layout, Tab } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';

import './index.scss';

const { Body, Content } = Layout;

interface IReuseTabPageTemplateProps extends IBaseProps {
  /**
   * 页面标题
   */
  title: string | React.ReactElement;
  /**
   * 页面副标题
   */
  subTitle?: string | React.ReactElement;
  /**
   * 页面打点配置的键映射
   */
  pageLogKeyMap?: IRecord<string>;
  /**
   * Tab的New标签的映射的键
   */
  newMarkIdsMappingKey?: string;
  /**
   * 页面tab配置
   */
  tabs: Tab[];
  /**
   * 当前选中tab的id
   */
  activeId: string;
  /**
   * 切换tab的回调
   * @param tab - tab
   * @param tab.id - tab的id
   */
  onActive?: (tab: { id: string }) => void;
}

const ReuseTabPageTemplate: React.FC<IReuseTabPageTemplateProps> = (props) => {
  const { style, className, title, subTitle, newMarkIdsMappingKey = '', tabs, activeId, onActive, children } = props;

  return (
    <Layout style={style} className={classnames('dbi-reuse-tab-page-template', className)}>
      <Body>
        <Content>
          <Content.Header
            className="dbi-reuse-tab-page-template__header"
            title={
              <div className="dbi-reuse-tab-page-template__header-title-wrapper">
                <span className="dbi-reuse-tab-page-template__header-title">{title}</span>
                <span className="dbi-reuse-tab-page-template__header-sub-title">{subTitle}</span>
              </div>
            }
            operation={null}
          >
            <Tabs
              ceiling
              animated={false}
              newMarkIdsMappingKey={newMarkIdsMappingKey}
              tabs={tabs}
              activeId={activeId}
              onActive={onActive}
            />
          </Content.Header>
          <Content.Body full className="dbi-reuse-tab-page-template__body">
            {children}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default ReuseTabPageTemplate;
